import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { IntegrationDetail } from 'src/app/core/interfaces/integration-detail.interface';
import { uuidWrapper } from 'src/app/shared/helpers/uuid';
import { createIntegrationDraft, deleteIntegration, deleteIntegrationDraft, getIntegrations, getIntegrationsHealth, saveIntegration, upsertIntegration } from '../../../store/integrations.actions';
import { fromIntegrations } from '../../../store/integrations.selectors';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ElementDefinitionTarget } from 'src/app/core/models/integration.model';

@Component({
  selector: 'app-integration',
  templateUrl: './integration.component.html',
  styleUrls: ['./integration.component.scss']
})
export class IntegrationComponent implements OnInit, OnDestroy {

  integrations$ = this.store.select(fromIntegrations.selectIntegrations);
  integrationDrafts$ = this.store.select(fromIntegrations.selectIntegrationDrafts);
  healthStatuses: Record<string, string> = {};
  onDestroy$ = new Subject<void>();

  constructor(private store: Store) { }

  ngOnInit(): void {
    this.store.dispatch(getIntegrations());
    this.store.select(fromIntegrations.selectHealthStatuses).pipe(takeUntil(this.onDestroy$)).subscribe(statuses => {
      this.healthStatuses = statuses;
    });
    this.store.dispatch(getIntegrationsHealth())
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  onAddIntegration() {
    this.store.dispatch(
      createIntegrationDraft(
        {
          draft:
          {
            id: uuidWrapper.uuid(),
            name: '',
            connectionString: '',
            type: ElementDefinitionTarget.Workroads
          }
        }));
  }

  onDeleteIntegration(integration: IntegrationDetail) {
    this.store.dispatch(deleteIntegration({ id: integration.id }));
  }

  onDeleteDraftIntegration(integration: IntegrationDetail) {
    this.store.dispatch(deleteIntegrationDraft({ id: integration.id }));
  }

  onSubmit($event: IntegrationDetail, isDraft: boolean) {
    this.store.dispatch(upsertIntegration({ integration: $event, isDraft }));
  }

  getStatus(_t8: IntegrationDetail): string | null {
    if (!this.healthStatuses) {
      return null;
    }
    return this.healthStatuses[_t8.id.toString()] || null;

  }
}
